import React, { useState, useEffect, useContext, useRef, useCallback, useMemo } from "react";
import { useHistory } from "react-router-dom";
import {
  makeStyles,
  Paper,
  InputBase,
  Tabs,
  Tab,
  Badge,
  IconButton,
  Typography,
  Grid,
  Tooltip,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import {
  Group,
  MoveToInbox as MoveToInboxIcon,
  CheckBox as CheckBoxIcon,
  MessageSharp as MessageSharpIcon,
  AccessTime as ClockIcon,
  Search as SearchIcon,
  Add as AddIcon,
  TextRotateUp,
  TextRotationDown,
  NotificationsActive as NotificationsActiveIcon,
  NotificationsOff as NotificationsOffIcon,
  SupervisorAccount as SupervisorAccountIcon,
} from "@material-ui/icons";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import ToggleButton from "@material-ui/lab/ToggleButton";

import { FilterAltOff, FilterAlt, PlaylistAddCheckOutlined, Checklist } from "@mui/icons-material";

import NewTicketModal from "../NewTicketModal";
import GroupPermissionsModal from "../GroupPermissionsModal";
import TicketsList from "../TicketsListCustom";
import TabPanel from "../TabPanel";
import { Can } from "../Can";
import TicketsQueueSelect from "../TicketsQueueSelect";
import { TagsFilter } from "../TagsFilter";
import { UsersFilter } from "../UsersFilter";
import { StatusFilter } from "../StatusFilter";
import { WhatsappsFilter } from "../WhatsappsFilter";
import { Button, Snackbar } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { QueueSelectedContext } from "../../context/QueuesSelected/QueuesSelectedContext";
import { useCompanySettingsContext } from "../../context/CompanySettings/CompanySettingsContext";
import toastError from "../../errors/toastError";
import toastUtils from "../../utils/toastUtils";

import api from "../../services/api";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const useStyles = makeStyles((theme) => ({
  ticketsWrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflow: "hidden",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },

  tabsHeader: {
    minWidth: "auto",
    width: "auto",
    borderRadius: 8,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },

  settingsIcon: {
    alignSelf: "center",
    marginLeft: "auto",
    padding: theme.spacing(1),
  },

  tab: {
    minWidth: "auto",
    width: "auto",
    padding: theme.spacing(0.5, 1),
    borderRadius: 8,
    transition: "0.3s",
    borderColor: "#aaa",
    borderWidth: "1px",
    borderStyle: "solid",
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),

    [theme.breakpoints.down("lg")]: {
      fontSize: "0.9rem",
      padding: theme.spacing(0.4, 0.8),
      marginRight: theme.spacing(0.4),
      marginLeft: theme.spacing(0.4),
    },

    [theme.breakpoints.down("md")]: {
      fontSize: "0.75rem",
      padding: theme.spacing(0.25, 0.5),
      marginRight: theme.spacing(0.25),
      marginLeft: theme.spacing(0.25),
    },

    // Específico para monitores de 11-13 polegadas
    '@media (max-width: 1366px)': {
      fontSize: "0.8rem",
      padding: theme.spacing(0.3, 0.6),
      marginRight: theme.spacing(0.3),
      marginLeft: theme.spacing(0.3),
    },

    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.1)",
    },
  },

  tabPanelItem: {
    minWidth: "33%",
    fontSize: 11,
    marginLeft: 0,
    [theme.breakpoints.down('sm')]: {
      minWidth: "30%",
      fontSize: 9,
      padding: theme.spacing(0.5),
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: "28%",
      fontSize: 8,
    },
  },
  
  tabPanelItemIconOnly: {
    minWidth: "auto",
    width: "auto",
    fontSize: 11,
    marginLeft: 0,
    padding: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0.5),
    },
  },

  tabIndicator: {
    height: 6,
    bottom: 0,
    borderRadius: "0 0 8px 8px",
    backgroundColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
  },
  tabsBadge: {
    top: "105%",
    right: "55%",
    transform: "translate(45%, 0)",
    whiteSpace: "nowrap",
    borderRadius: "12px",
    padding: "0 8px",
    backgroundColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    color: theme.mode === "light" ? "#FFF" : theme.palette.primary.main,
  },
  ticketOptionsBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: theme.palette.optionsBackground,
    borderRadius: 8,
    borderColor: "#aaa",
    borderWidth: "1px",
    borderStyle: "solid",
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5), // ✅ PADRONIZADO: Margin consistente com serachInputWrapper
    marginLeft: theme.spacing(0.5), // ✅ PADRONIZADO: Margin consistente
    marginRight: theme.spacing(0.5), // ✅ PADRONIZADO: Margin consistente
    padding: theme.spacing(0.5),
    minHeight: 48, // ✅ PADRONIZADO: Altura mínima consistente
    boxSizing: "border-box", // ✅ PADRONIZADO: Box-sizing consistente
  },

  serachInputWrapper: {
    flex: 1,
    height: 40,
    minHeight: 40,
    maxHeight: 40,
    background: theme.palette.total,
    display: "flex",
    borderRadius: 8,
    padding: "2px 6px",
    borderColor: "#aaa",
    borderWidth: "1px",
    borderStyle: "solid",
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    alignItems: "center",
    boxSizing: "border-box",
    [theme.breakpoints.down('sm')]: {
      height: 36,
      minHeight: 36,
      maxHeight: 36,
      padding: "2px 4px",
    },
  },

  searchIcon: {
    color: "grey",
    marginLeft: 4,
    marginRight: 6,
    alignSelf: "center",
    fontSize: 20,
    flexShrink: 0,
  },

  searchInput: {
    flex: 1,
    minWidth: 0,
    border: "none",
    borderRadius: 8,
    height: "100%",
    alignSelf: "stretch",
    fontSize: "0.85rem",
    "& input": {
      fontSize: "0.85rem",
      padding: "4px 0",
      textOverflow: "ellipsis",
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: "0.78rem",
      "& input": {
        fontSize: "0.78rem",
      },
    },
  },

  switchWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    flexShrink: 0,
    margin: "0 2px",
    "& .MuiSwitch-root": {
      width: 36,
      height: 22,
      padding: 0,
      display: "flex",
      alignItems: "center",
    },
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(14px)",
      },
    },
    "& .MuiSwitch-thumb": {
      width: 18,
      height: 18,
    },
    "& .MuiSwitch-track": {
      borderRadius: 11,
      opacity: 1,
    },
  },

  badge: {
    // right: "-10px",
  },

  customBadge: {
    right: "-10px",
    backgroundColor: "#f44336",
    color: "#fff",
  },

  show: {
    display: "block",
  },

  hide: {
    display: "none !important",
  },

  closeAllFab: {
    backgroundColor: "red",
    marginBottom: "4px",
    "&:hover": {
      backgroundColor: "darkred",
    },
  },

  speedDial: {
    position: "absolute",
    bottom: theme.spacing(1),
    right: theme.spacing(1),
    "& .MuiFab-root": {
      width: "40px",
      height: "40px",
      marginTop: "4px",
    },
    "& .MuiFab-label": {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },

  snackbar: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: theme.palette.primary.main,
    color: "white",
    borderRadius: 30,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8em",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1em",
    },
  },

  yesButton: {
    backgroundColor: "#FFF",
    color: "rgba(0, 100, 0, 1)",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "darkGreen",
      color: "#FFF",
    },
    borderRadius: 30,
  },
  noButton: {
    backgroundColor: "#FFF",
    color: "rgba(139, 0, 0, 1)",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    "&:hover": {
      backgroundColor: "darkRed",
      color: "#FFF",
    },
    borderRadius: 30,
  },
  filterIcon: {
    padding: "4px !important",
    color: theme.mode === "light" ? "#0872b9" : "#FFF",
    cursor: "pointer",
    flexShrink: 0,
    marginLeft: 2,
    marginRight: 2,
  },
  button: {
    height: 30,
    width: 30,
    border: "2px solid",
    borderColor: "#aaa",
    borderRadius: 8,
    marginRight: 8,
    "&:hover": {
      borderColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  icon: {
    color: "#aaa",
    "&:hover": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  buttonOpen: {
    "& $icon": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  // Classe padronizada para todos os botões de ação
  standardButton: {
    height: "30px !important",
    width: "30px !important",
    minHeight: "30px !important",
    maxHeight: "30px !important",
    minWidth: "30px !important",
    maxWidth: "30px !important",
    border: "2px solid #aaa !important",
    borderRadius: "8px !important",
    marginRight: 6,
    padding: "0 !important",
    boxSizing: "border-box !important",
    display: "inline-flex !important",
    alignItems: "center !important",
    justifyContent: "center !important",
    "& .MuiIconButton-label": {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "&:hover": {
      borderColor: theme.mode === "light" ? `${theme.palette.primary.main} !important` : "#FFF !important",
    },
    [theme.breakpoints.down('sm')]: {
      height: "28px !important",
      width: "28px !important",
      minHeight: "28px !important",
      maxHeight: "28px !important",
      minWidth: "28px !important",
      maxWidth: "28px !important",
      marginRight: 4,
    },
    // Ajuste para monitores pequenos (11-13 polegadas)
    '@media (max-width: 1366px)': {
      height: "28px !important",
      width: "28px !important",
      minHeight: "28px !important",
      maxHeight: "28px !important",
      minWidth: "28px !important",
      maxWidth: "28px !important",
      marginRight: 4,
    },
  },
  // ✅ NOVA CLASSE: Botão de ordenação com espaçamento reduzido
  lastActionButton: {
    height: "30px !important",
    width: "30px !important",
    minHeight: "30px !important",
    maxHeight: "30px !important",
    minWidth: "30px !important",
    maxWidth: "30px !important",
    border: "2px solid #aaa !important",
    borderRadius: "8px !important",
    marginRight: 3,
    padding: "0 !important",
    boxSizing: "border-box !important",
    display: "inline-flex !important",
    alignItems: "center !important",
    justifyContent: "center !important",
    "& .MuiIconButton-label": {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "&:hover": {
      borderColor: theme.mode === "light" ? `${theme.palette.primary.main} !important` : "#FFF !important",
    },
    [theme.breakpoints.down('sm')]: {
      height: "28px !important",
      width: "28px !important",
      minHeight: "28px !important",
      maxHeight: "28px !important",
      minWidth: "28px !important",
      maxWidth: "28px !important",
      marginRight: 3,
    },
    // Ajuste para monitores pequenos (11-13 polegadas)
    '@media (max-width: 1366px)': {
      height: "28px !important",
      width: "28px !important",
      minHeight: "28px !important",
      maxHeight: "28px !important",
      minWidth: "28px !important",
      maxWidth: "28px !important",
      marginRight: 3,
    },
  },
  activeButton: {
    borderColor: `${theme.mode === "light" ? theme.palette.primary.main : "#FFF"} !important`,
    borderWidth: "2px !important",
  },
  standardIcon: {
    color: "#aaa",
    fontSize: 18,
    "&:hover": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  activeIcon: {
    color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
  },
}));

const TicketsManagerTabs = () => {
  const classes = useStyles();
  const history = useHistory();

  const [searchParam, setSearchParam] = useState("");
  const [tab, setTab] = useState("open");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [showAllTickets, setShowAllTickets] = useState(false);
  const [sortTickets, setSortTickets] = useState(false);

  const searchInputRef = useRef();
  const [searchOnMessages, setSearchOnMessages] = useState(false);

  const { user } = useContext(AuthContext);
  const { profile } = user;
  const { setSelectedQueuesMessage } = useContext(QueueSelectedContext);
  const { tabOpen, setTabOpen } = useContext(TicketsContext);
  
  // ✅ Hook otimizado para settings sem loops infinitos
  const { getSetting, loaded, hasSettings, settings } = useCompanySettingsContext();

  // Estados para configurações das tabs
  const [showTabLabels, setShowTabLabels] = useState(true);
  const [showTabBadges, setShowTabBadges] = useState(true);
  const [showActionButtons, setShowActionButtons] = useState(true);
  const [enableFiltersSection, setEnableFiltersSection] = useState(true);

  // ✅ SOLUÇÃO: Memoizar configurações de tabs para evitar re-renders desnecessários
  const tabSettings = useMemo(() => {
    if (!loaded || !hasSettings) {
      return {
        showTabLabels: true,
        showTabBadges: true,
        showActionButtons: true,
        enableFiltersSection: true
      };
    }

    return {
      showTabLabels: getSetting("showTabLabels", "true") !== "false",
      showTabBadges: getSetting("showTabBadges", "true") !== "false",
      showActionButtons: getSetting("showActionButtons", "true") !== "false",
      enableFiltersSection: getSetting("enableFiltersSection", "true") !== "false"
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded, hasSettings, settings]); // ← Dependência de settings em vez de getSetting

  // ✅ SOLUÇÃO: useEffect otimizado sem dependência de getSetting problemática
  useEffect(() => {
    if (loaded && hasSettings) {
      setShowTabLabels(tabSettings.showTabLabels);
      setShowTabBadges(tabSettings.showTabBadges);
      setShowActionButtons(tabSettings.showActionButtons);
      setEnableFiltersSection(tabSettings.enableFiltersSection);
    }
  }, [loaded, hasSettings, tabSettings]); // ← Dependência de tabSettings (memoizado) em vez de getSetting

  const [openCount, setOpenCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [groupingCount, setGroupingCount] = useState(0);

  const userQueueIds = user && user.queues ? user.queues.map((q) => q.id) : [];
  const [selectedQueueIds, setSelectedQueueIds] = useState(userQueueIds || []);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedWhatsapp, setSelectedWhatsapp] = useState([]);
  const [forceSearch, setForceSearch] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [filter, setFilter] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isHoveredAll, setIsHoveredAll] = useState(false);
  const [isHoveredNew, setIsHoveredNew] = useState(false);
  const [isHoveredResolve, setIsHoveredResolve] = useState(false);
  const [isHoveredOpen, setIsHoveredOpen] = useState(false);
  const [isHoveredClosed, setIsHoveredClosed] = useState(false);
  const [isHoveredSort, setIsHoveredSort] = useState(false);
  const [isHoveredGroupBadge, setIsHoveredGroupBadge] = useState(false);
  const [showGroupBadge, setShowGroupBadge] = useState(() => {
    const saved = localStorage.getItem("showGroupBadge");
    return saved !== null ? JSON.parse(saved) : true;
  });

  const handleToggleGroupBadge = () => {
    setShowGroupBadge((prevState) => {
      const newState = !prevState;
      localStorage.setItem("showGroupBadge", JSON.stringify(newState));
      return newState;
    });
  };

  const [selectionMode, setSelectionMode] = useState(false);
  const [muteAllDialogOpen, setMuteAllDialogOpen] = useState(false);
  const [isHoveredSelectMode, setIsHoveredSelectMode] = useState(false);
  const [isHoveredMuteAll, setIsHoveredMuteAll] = useState(false);
  const [groupPermissionsModalOpen, setGroupPermissionsModalOpen] = useState(false);
  const [isHoveredGroupPermissions, setIsHoveredGroupPermissions] = useState(false);

  const getTabLabel = (status) => {
    switch (status) {
      case "open":
        return i18n.t("ticketsList.assignedHeader") || "Atendendo";
      case "pending":
        return i18n.t("ticketsList.pendingHeader") || "Aguardando";
      case "group":
        return i18n.t("ticketsList.groupingHeader") || "Grupos";
      default:
        return status;
    }
  };

  const handleMuteAll = async (isMuted) => {
    try {
      await api.post("/tickets/muteAll", {
        status: tabOpen,
        isMuted,
        queueIds: selectedQueueIds,
      });
      window.dispatchEvent(new CustomEvent("tabMuteAll", { detail: { status: tabOpen, isMuted } }));
      setMuteAllDialogOpen(false);
      toastUtils.success(
        isMuted ? "Silenciado" : "Reativado",
        isMuted
          ? `Todas as notificações de ${getTabLabel(tabOpen)} foram silenciadas.`
          : `Notificações de ${getTabLabel(tabOpen)} foram reativadas.`
      );
    } catch (err) {
      toastError(err);
    }
  };

  const [isFilterActive, setIsFilterActive] = useState(false);

  useEffect(() => {
    setSelectedQueuesMessage(selectedQueueIds);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedQueueIds]);

  useEffect(() => {
    if (user.profile.toUpperCase() === "ADMIN" || user.allUserChat.toUpperCase() === "ENABLED") {
      setShowAllTickets(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (tab === "search") {
      searchInputRef.current.focus();
    }
    setForceSearch(!forceSearch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  // ✅ Refs para controle de timeout com cleanup automático
  const searchTimeoutRef = useRef(null);
  const tagsTimeoutRef = useRef(null);
  const usersTimeoutRef = useRef(null);
  const whatsappsTimeoutRef = useRef(null);
  const statusTimeoutRef = useRef(null);

  // ✅ SOLUÇÃO: Cleanup automático de todos os timeouts ao desmontar
  useEffect(() => {
    return () => {
      // Cleanup de todos os timeouts
      [searchTimeoutRef, tagsTimeoutRef, usersTimeoutRef, whatsappsTimeoutRef, statusTimeoutRef].forEach(ref => {
        if (ref.current) {
          clearTimeout(ref.current);
          ref.current = null;
        }
      });
    };
  }, []);

  // ✅ SOLUÇÃO: Função helper para cleanup de timeout específico
  const clearTimeoutSafely = useCallback((timeoutRef) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  const handleSearch = (e) => {
    const searchedTerm = e.target.value.toLowerCase();

    // ✅ Usar função helper para cleanup seguro
    clearTimeoutSafely(searchTimeoutRef);

    if (searchedTerm === "") {
      setSearchParam(searchedTerm);
      setForceSearch(!forceSearch);
      setTab("open");
      return;
    } else if (tab !== "search") {
      handleFilter();
      setTab("search");
    }

    // ✅ Usar ref para o timeout com cleanup automático
    searchTimeoutRef.current = setTimeout(() => {
      setSearchParam(searchedTerm);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleBack = () => {
    history.push("/tickets");
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  const handleChangeTabOpen = (e, newValue) => {
    handleBack();
    setTabOpen(newValue);
    setSelectionMode(false);
  };

  const applyPanelStyle = (status) => {
    if (tabOpen !== status) {
      return { width: 0, height: 0 };
    }
  };

  const handleSnackbarOpen = () => {
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const CloseAllTicket = async () => {
    try {
      await api.post("/tickets/closeAll", {
        status: tabOpen,
        selectedQueueIds,
      });
      handleSnackbarClose();
    } catch (err) {
      toastError(err);
    }
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      history.push(`/tickets/${ticket.uuid}`);
    }
  };

  const handleSelectedTags = (selecteds) => {
    const tags = selecteds.map((t) => t.id);

    // ✅ Usar função helper para cleanup seguro
    clearTimeoutSafely(tagsTimeoutRef);

    if (tags.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }

    tagsTimeoutRef.current = setTimeout(() => {
      setSelectedTags(tags);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedUsers = (selecteds) => {
    const users = selecteds.map((t) => t.id);

    // ✅ Usar função helper para cleanup seguro
    clearTimeoutSafely(usersTimeoutRef);

    if (users.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }
    
    usersTimeoutRef.current = setTimeout(() => {
      setSelectedUsers(users);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedWhatsapps = (selecteds) => {
    const whatsapp = selecteds.map((t) => t.id);

    // ✅ Usar função helper para cleanup seguro
    clearTimeoutSafely(whatsappsTimeoutRef);

    if (whatsapp.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }
    
    whatsappsTimeoutRef.current = setTimeout(() => {
      setSelectedWhatsapp(whatsapp);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedStatus = (selecteds) => {
    const statusFilter = selecteds.map((t) => t.status);

    // ✅ Usar função helper para cleanup seguro
    clearTimeoutSafely(statusTimeoutRef);

    if (statusFilter.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }
    
    statusTimeoutRef.current = setTimeout(() => {
      setSelectedStatus(statusFilter);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleFilter = () => {
    if (filter) {
      setFilter(false);
      setTab("open");
      setSearchParam("");
      setSelectedTags([]);
      setSelectedUsers([]);
      setSelectedWhatsapp([]);
      setSelectedStatus([]);
      setForceSearch(!forceSearch);
      
      // ✅ Cleanup de todos os timeouts ao resetar filtros
      [searchTimeoutRef, tagsTimeoutRef, usersTimeoutRef, whatsappsTimeoutRef, statusTimeoutRef].forEach(ref => {
        clearTimeoutSafely(ref);
      });
      
      if (searchInputRef.current) {
        searchInputRef.current.value = "";
      }
    } else {
      setFilter(true);
      setTab("search");
    }
  };

  return (
    <Paper elevation={0} variant="outlined" className={classes.ticketsWrapper}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />
      <GroupPermissionsModal
        open={groupPermissionsModalOpen}
        onClose={() => setGroupPermissionsModalOpen(false)}
      />
      <div className={classes.serachInputWrapper}>
        <SearchIcon className={classes.searchIcon} />
        <InputBase
          className={classes.searchInput}
          inputRef={searchInputRef}
          placeholder={i18n.t("tickets.search.placeholder")}
          type="search"
          onChange={handleSearch}
        />
        <Tooltip placement="top" title="Marque para pesquisar também nos conteúdos das mensagens (mais lento)">
          <div className={classes.switchWrapper}>
            <Switch
              size="small"
              checked={searchOnMessages}
              onChange={(e) => { setSearchOnMessages(e.target.checked) }}
            />
          </div>
        </Tooltip>
        <IconButton
          size="small"
          aria-label="filter"
          className={classes.filterIcon}
          onClick={() => {
            setIsFilterActive((prevState) => !prevState);
            handleFilter();
          }}
        >
          {isFilterActive ? (
            <FilterAlt style={{ fontSize: 20 }} className={classes.icon} />
          ) : (
            <FilterAltOff style={{ fontSize: 20 }} className={classes.icon} />
          )}
        </IconButton>
      </div>

      {filter === true && enableFiltersSection && (
        <>
          <TagsFilter onFiltered={handleSelectedTags} />
          <WhatsappsFilter onFiltered={handleSelectedWhatsapps} />
          <StatusFilter onFiltered={handleSelectedStatus} />
          {profile === "admin" && (
            <>
              <UsersFilter onFiltered={handleSelectedUsers} />
            </>
          )}
        </>
      )}

      <Paper square elevation={0} className={classes.ticketOptionsBox}>
        <Grid container alignItems="center" justifyContent="space-between">
          {showActionButtons && (
            <Grid item>
              <Can
                role={user.allUserChat === 'enabled' && user.profile === 'user' ? 'admin' : user.profile}
                perform="tickets-manager:showall"
                yes={() => (
  <Badge
  color="primary"
  invisible={
    !isHoveredAll ||
    isHoveredNew ||
    isHoveredResolve ||
    isHoveredOpen ||
    isHoveredClosed ||
    isHoveredSort ||
    isHoveredGroupBadge
  }
  badgeContent={"Todos"}
  classes={{ badge: classes.tabsBadge }}
>
  <ToggleButton
    onMouseEnter={() => setIsHoveredAll(true)}
    onMouseLeave={() => setIsHoveredAll(false)}
    className={`${classes.standardButton} ${showAllTickets ? classes.activeButton : ''}`}
    value="uncheck"
    selected={showAllTickets}
    onChange={() => setShowAllTickets((prevState) => !prevState)}
  >
    {showAllTickets ? (
      <VisibilityIcon className={`${classes.standardIcon} ${classes.activeIcon}`} />
    ) : (
      <VisibilityOffIcon className={classes.standardIcon} />
    )}
  </ToggleButton>
</Badge>
              )}
            />
            <Snackbar
              open={snackbarOpen}
              onClose={handleSnackbarClose}
              message={i18n.t("tickets.inbox.closedAllTickets")}
              ContentProps={{
                className: classes.snackbar,
              }}
              action={
                <>
                  <Button
                    className={classes.yesButton}
                    size="small"
                    onClick={CloseAllTicket}
                  >
                    {i18n.t("tickets.inbox.yes")}
                  </Button>
                  <Button
                    className={classes.noButton}
                    size="small"
                    onClick={handleSnackbarClose}
                  >
                    {i18n.t("tickets.inbox.no")}
                  </Button>
                </>
              }
            />
<Badge
  color="primary"
  invisible={
    isHoveredAll ||
    !isHoveredNew ||
    isHoveredResolve ||
    isHoveredOpen ||
    isHoveredClosed ||
    isHoveredSort ||
    isHoveredGroupBadge
  }
  badgeContent={i18n.t("tickets.inbox.newTicket")}
  classes={{ badge: classes.tabsBadge }}
>
  <IconButton
    onMouseEnter={() => setIsHoveredNew(true)}
    onMouseLeave={() => setIsHoveredNew(false)}
    className={classes.standardButton}
    onClick={() => {
      setNewTicketModalOpen(true);
    }}
  >
    <AddIcon className={classes.standardIcon} />
  </IconButton>
</Badge>
{user.profile === "admin" && (
  <Badge
    color="primary"
    invisible={
      isHoveredAll ||
      isHoveredNew ||
      !isHoveredResolve ||
      isHoveredOpen ||
      isHoveredClosed ||
      isHoveredSort ||
      isHoveredGroupBadge
    }
    badgeContent={i18n.t("tickets.inbox.closedAll")}
    classes={{ badge: classes.tabsBadge }}
  >
    <IconButton
      onMouseEnter={() => setIsHoveredResolve(true)}
      onMouseLeave={() => setIsHoveredResolve(false)}
      className={classes.standardButton}
      onClick={handleSnackbarOpen}
    >
      <PlaylistAddCheckOutlined className={classes.standardIcon} />
    </IconButton>
  </Badge>
)}
{/* Botão "Abertos" */}
<Badge
  invisible={
    !(
      tab === "open" &&
      !isHoveredAll &&
      !isHoveredNew &&
      !isHoveredResolve &&
      !isHoveredClosed &&
      !isHoveredSort &&
      !isHoveredGroupBadge
    ) && !isHoveredOpen
  }
  badgeContent={i18n.t("tickets.inbox.open")}
  classes={{ badge: classes.tabsBadge }}
>
  <IconButton
    onMouseEnter={() => setIsHoveredOpen(true)}
    onMouseLeave={() => setIsHoveredOpen(false)}
    className={`${classes.standardButton} ${
      (tab === "open" || isHoveredOpen) ? classes.activeButton : ''
    }`}
    onClick={() => handleChangeTab(null, "open")}
  >
    <MoveToInboxIcon
      className={`${classes.standardIcon} ${
        (tab === "open" || isHoveredOpen) ? classes.activeIcon : ''
      }`}
    />
  </IconButton>
</Badge>

{/* Botão "Resolvidos" */}
<Badge
  color="primary"
  invisible={
    !(
      tab === "closed" &&
      !isHoveredAll &&
      !isHoveredNew &&
      !isHoveredResolve &&
      !isHoveredOpen &&
      !isHoveredSort &&
      !isHoveredGroupBadge
    ) && !isHoveredClosed
  }
  badgeContent={i18n.t("tickets.inbox.resolverd")}
  classes={{ badge: classes.tabsBadge }}
>
  <IconButton
    onMouseEnter={() => setIsHoveredClosed(true)}
    onMouseLeave={() => setIsHoveredClosed(false)}
    className={`${classes.standardButton} ${
      (tab === "closed" || isHoveredClosed) ? classes.activeButton : ''
    }`}
    onClick={() => handleChangeTab(null, "closed")}
  >
    <CheckBoxIcon
      className={`${classes.standardIcon} ${
        (tab === "closed" || isHoveredClosed) ? classes.activeIcon : ''
      }`}
    />
  </IconButton>
</Badge>

{tab !== "closed" && tab !== "search" && (
  <Badge
    color="primary"
    invisible={
      !isHoveredSort ||
      isHoveredAll ||
      isHoveredNew ||
      isHoveredResolve ||
      isHoveredOpen ||
      isHoveredClosed ||
      isHoveredGroupBadge
    }
    badgeContent={!sortTickets ? "Crescente" : "Decrescente"}
    classes={{ badge: classes.tabsBadge }}
  >
    <ToggleButton
      onMouseEnter={() => setIsHoveredSort(true)}
      onMouseLeave={() => setIsHoveredSort(false)}
      className={`${user.allowGroup ? classes.standardButton : classes.lastActionButton} ${sortTickets ? classes.activeButton : ''}`}
      value="uncheck"
      selected={sortTickets}
      onChange={() => setSortTickets((prevState) => !prevState)}
    >
      {!sortTickets ? (
        <TextRotateUp className={`${classes.standardIcon} ${sortTickets ? classes.activeIcon : ''}`} />
      ) : (
        <TextRotationDown className={`${classes.standardIcon} ${classes.activeIcon}`} />
      )}
    </ToggleButton>
  </Badge>
)}

{user.allowGroup && tab !== "closed" && tab !== "search" && (
  <Badge
    color="primary"
    invisible={
      !isHoveredGroupBadge ||
      isHoveredAll ||
      isHoveredNew ||
      isHoveredResolve ||
      isHoveredOpen ||
      isHoveredClosed ||
      isHoveredSort ||
      isHoveredGroupPermissions
    }
    badgeContent={showGroupBadge ? "Ocultar Contador Grupos" : "Exibir Contador Grupos"}
    classes={{ badge: classes.tabsBadge }}
  >
    <ToggleButton
      onMouseEnter={() => setIsHoveredGroupBadge(true)}
      onMouseLeave={() => setIsHoveredGroupBadge(false)}
      className={`${classes.standardButton} ${showGroupBadge ? classes.activeButton : ''}`}
      value="check"
      selected={showGroupBadge}
      onChange={handleToggleGroupBadge}
    >
      {showGroupBadge ? (
        <NotificationsActiveIcon className={`${classes.standardIcon} ${classes.activeIcon}`} />
      ) : (
        <NotificationsOffIcon className={classes.standardIcon} />
      )}
    </ToggleButton>
  </Badge>
)}

{user.profile === "admin" && user.allowGroup && tab !== "closed" && tab !== "search" && (
  <Badge
    color="primary"
    invisible={!isHoveredGroupPermissions}
    badgeContent="Permissões de Grupos"
    classes={{ badge: classes.tabsBadge }}
  >
    <IconButton
      onMouseEnter={() => setIsHoveredGroupPermissions(true)}
      onMouseLeave={() => setIsHoveredGroupPermissions(false)}
      className={classes.standardButton}
      onClick={(e) => {
        if (e?.currentTarget?.blur) e.currentTarget.blur();
        setGroupPermissionsModalOpen(true);
      }}
    >
      <SupervisorAccountIcon className={classes.standardIcon} />
    </IconButton>
  </Badge>
)}

{tab !== "closed" && tab !== "search" && (
  <Badge
    color="primary"
    invisible={!isHoveredSelectMode}
    badgeContent={selectionMode ? "Sair da Seleção" : "Modo Seleção"}
    classes={{ badge: classes.tabsBadge }}
  >
    <ToggleButton
      onMouseEnter={() => setIsHoveredSelectMode(true)}
      onMouseLeave={() => setIsHoveredSelectMode(false)}
      className={`${classes.standardButton} ${selectionMode ? classes.activeButton : ''}`}
      value="check"
      selected={selectionMode}
      onChange={() => setSelectionMode((prev) => !prev)}
    >
      <Checklist className={`${classes.standardIcon} ${selectionMode ? classes.activeIcon : ''}`} />
    </ToggleButton>
  </Badge>
)}

{tab !== "closed" && tab !== "search" && (
  <Badge
    color="primary"
    invisible={!isHoveredMuteAll}
    badgeContent={`Silenciar / Ativar Som (${getTabLabel(tabOpen)})`}
    classes={{ badge: classes.tabsBadge }}
  >
    <IconButton
      onMouseEnter={() => setIsHoveredMuteAll(true)}
      onMouseLeave={() => setIsHoveredMuteAll(false)}
      className={classes.lastActionButton}
      onClick={(e) => {
        if (e?.currentTarget?.blur) e.currentTarget.blur();
        setMuteAllDialogOpen(true);
      }}
    >
      <NotificationsOffIcon className={classes.standardIcon} />
    </IconButton>
  </Badge>
)}
            </Grid>
          )}
          <Grid item>
            <TicketsQueueSelect
              selectedQueueIds={selectedQueueIds}
              userQueues={user?.queues}
              onChange={(values) => setSelectedQueueIds(values)}
            />
          </Grid>
        </Grid>
      </Paper>

      <TabPanel value={tab} name="open" className={classes.ticketsWrapper}>
        <Tabs
          value={tabOpen}
          onChange={handleChangeTabOpen}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          scrollButtons="auto"
        >
          {/* ATENDENDO */}
          <Tab
            label={
              <Grid container alignItems="center" justifyContent="center">
                <Grid item>
                  <Badge
                    overlap="rectangular"
                    classes={{ badge: classes.customBadge }}
                    badgeContent={showTabBadges ? openCount : 0}
                    color="primary"
                  >
                    <MessageSharpIcon
                      style={{
                        fontSize: 18,
                      }}
                    />
                  </Badge>
                </Grid>
                {showTabLabels && (
                  <Grid item>
                    <Typography
                      style={{
                        marginLeft: 8,
                        fontSize: 10,
                        fontWeight: 600,
                      }}
                    >
                      {i18n.t("ticketsList.assignedHeader")}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            }
            value={"open"}
            name="open"
            classes={{ root: showTabLabels ? classes.tabPanelItem : classes.tabPanelItemIconOnly }}
          />

          {/* AGUARDANDO */}
          <Tab
            label={
              <Grid container alignItems="center" justifyContent="center">
                <Grid item>
                  <Badge
                    overlap="rectangular"
                    classes={{ badge: classes.customBadge }}
                    badgeContent={showTabBadges ? pendingCount : 0}
                    color="primary"
                  >
                    <ClockIcon
                      style={{
                        fontSize: 18,
                      }}
                    />
                  </Badge>
                </Grid>
                {showTabLabels && (
                  <Grid item>
                    <Typography
                      style={{
                        marginLeft: 8,
                        fontSize: 10,
                        fontWeight: 600,
                      }}
                    >
                      {i18n.t("ticketsList.pendingHeader")}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            }
            value={"pending"}
            name="pending"
            classes={{ root: showTabLabels ? classes.tabPanelItem : classes.tabPanelItemIconOnly }}
          />

          {/* GRUPOS */}
          {user.allowGroup && (
            <Tab
              label={
                <Grid container alignItems="center" justifyContent="center">
                  <Grid item>
                    <Badge
                      overlap="rectangular"
                      classes={{ badge: classes.customBadge }}
                      badgeContent={showTabBadges && showGroupBadge ? groupingCount : 0}
                      invisible={!showTabBadges || !showGroupBadge || groupingCount === 0}
                      color="primary"
                    >
                      <Group
                        style={{
                          fontSize: 18,
                        }}
                      />
                    </Badge>
                  </Grid>
                  {showTabLabels && (
                    <Grid item>
                      <Typography
                        style={{
                          marginLeft: 8,
                          fontSize: 10,
                          fontWeight: 600,
                        }}
                      >
                        {i18n.t("ticketsList.groupingHeader")}
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              }
              value={"group"}
              name="group"
              classes={{ root: showTabLabels ? classes.tabPanelItem : classes.tabPanelItemIconOnly }}
            />
          )}
        </Tabs>

        <Paper className={classes.ticketsWrapper}>
          <TicketsList
            status="open"
            showAll={showAllTickets}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            selectedQueueIds={selectedQueueIds}
            updateCount={(val) => setOpenCount(val)}
            style={applyPanelStyle("open")}
            setTabOpen={setTabOpen}
            selectionMode={tabOpen === "open" ? selectionMode : false}
            setSelectionMode={setSelectionMode}
          />
          <TicketsList
            status="pending"
            selectedQueueIds={selectedQueueIds}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            showAll={user.profile === "admin" || user.allUserChat === 'enabled' ? showAllTickets : false}
            updateCount={(val) => setPendingCount(val)}
            style={applyPanelStyle("pending")}
            setTabOpen={setTabOpen}
            selectionMode={tabOpen === "pending" ? selectionMode : false}
            setSelectionMode={setSelectionMode}
          />
          {user.allowGroup && (
            <TicketsList
              status="group"
              showAll={showAllTickets}
              sortTickets={sortTickets ? "ASC" : "DESC"}
              selectedQueueIds={selectedQueueIds}
              updateCount={(val) => setGroupingCount(val)}
              style={applyPanelStyle("group")}
              setTabOpen={setTabOpen}
              selectionMode={tabOpen === "group" ? selectionMode : false}
              setSelectionMode={setSelectionMode}
            />
          )}
        </Paper>
      </TabPanel>

      <TabPanel value={tab} name="closed" className={classes.ticketsWrapper}>
        <TicketsList
          status="closed"
          showAll={showAllTickets}
          selectedQueueIds={selectedQueueIds}
          setTabOpen={setTabOpen}
        />
      </TabPanel>

      <TabPanel value={tab} name="search" className={classes.ticketsWrapper}>
        {profile === "admin" && (
          <>
            <TicketsList
              statusFilter={selectedStatus}
              searchParam={searchParam}
              showAll={showAllTickets}
              tags={selectedTags}
              users={selectedUsers}
              selectedQueueIds={selectedQueueIds}
              whatsappIds={selectedWhatsapp}
              forceSearch={forceSearch}
              searchOnMessages={searchOnMessages}
              status="search"
            />
          </>
        )}

        {profile === "user" && (
          <TicketsList
            statusFilter={selectedStatus}
            searchParam={searchParam}
            showAll={false}
            tags={selectedTags}
            selectedQueueIds={selectedQueueIds}
            whatsappIds={selectedWhatsapp}
            forceSearch={forceSearch}
            searchOnMessages={searchOnMessages}
            status="search"
          />
        )}
      </TabPanel>

      {/* Diálogo de confirmação Silenciar / Reativar Todos */}
      <Dialog
        open={muteAllDialogOpen}
        onClose={() => setMuteAllDialogOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          Notificações: {getTabLabel(tabOpen)}
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="textSecondary">
            Deseja silenciar ou reativar as notificações sonoras de todos os tickets da aba <strong>{getTabLabel(tabOpen)}</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setMuteAllDialogOpen(false)}
            color="default"
          >
            Cancelar
          </Button>
          <Button
            onClick={() => handleMuteAll(false)}
            style={{ color: "#388e3c" }}
            startIcon={<NotificationsActiveIcon />}
          >
            Reativar Som
          </Button>
          <Button
            onClick={() => handleMuteAll(true)}
            style={{ color: "#d32f2f" }}
            startIcon={<NotificationsOffIcon />}
          >
            Silenciar Todos
          </Button>
        </DialogActions>
      </Dialog>
    </Paper >
  );
};

export default TicketsManagerTabs;